import { createSelector } from 'reselect';

export const selectOccupationsSlice = state => state.occupations;

export const selectOccupations = createSelector(
  selectOccupationsSlice,
  slice => slice.occupations
);
export const occupationsLoaded = createSelector(
  selectOccupationsSlice,
  slice => slice.occupationsLoaded
);
export const selectActiveOccupation = createSelector(
  selectOccupationsSlice,
  slice => slice.activeOccupation
);

export const occupationsMeta = createSelector(
  selectOccupationsSlice,
  slice => slice.meta
);
export const occupationsFilters = createSelector(
  selectOccupationsSlice,
  slice => slice.filters
);

export const occupationCreating = createSelector(
  selectOccupationsSlice,
  slice => slice.isCreating
);
export const occupationUpdating = createSelector(
  selectOccupationsSlice,
  slice => slice.isUpdating
);
export const occupationDeleting = createSelector(
  selectOccupationsSlice,
  slice => slice.isDeleting
);
export const occupationsErrors = createSelector(
  selectOccupationsSlice,
  slice => slice.errors
);
